import { useCallback, useSyncExternalStore } from 'react';

const useSessionStorage = (key: string) => {
  const setStorage = useCallback(
    (newValue: string) => {
      sessionStorage.setItem(key, newValue);
      dispatchEvent(new StorageEvent('storage', { key: key, newValue }));
    },
    [key],
  );

  const removeStorage = useCallback(() => {
    sessionStorage.removeItem(key);
    dispatchEvent(new StorageEvent('storage', { key: key }));
  }, [key]);

  const removeAllStorage = useCallback(() => {
    sessionStorage.clear();
    dispatchEvent(new StorageEvent('storage'));
  }, [key]);

  const getSnapshot = () => sessionStorage.getItem(key);

  const subscribe = (listener: () => void) => {
    window.addEventListener('storage', listener);
    return () => window.removeEventListener('storage', listener);
  };

  const store = useSyncExternalStore(subscribe, getSnapshot);

  return { value: store, set: setStorage, remove: removeStorage, removeAllStorage };
};

export default useSessionStorage;
